module.exports = __webpack_public_path__ + "static/media/PF_Faucet-Multipliers.3a7fb41c.jpg";